import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card mb-5 mb-xl-10" }
const _hoisted_3 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_4 = { class: "card-body border-top p-9" }
const _hoisted_5 = { class: "row mb-6" }
const _hoisted_6 = { class: "col-lg-6 fv-row" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Nama Sekolah", -1)
const _hoisted_8 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_9 = { class: "fv-help-block" }
const _hoisted_10 = { class: "col-lg-6 fv-row" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Nomor PKS", -1)
const _hoisted_12 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_13 = { class: "fv-help-block" }
const _hoisted_14 = { class: "row mb-6" }
const _hoisted_15 = { class: "col-lg-6 fv-row" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Tanggal Mulai", -1)
const _hoisted_17 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_18 = { class: "fv-help-block" }
const _hoisted_19 = { class: "col-lg-6 fv-row" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Tanggal Selesai", -1)
const _hoisted_21 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_22 = { class: "fv-help-block" }
const _hoisted_23 = { class: "row mb-6" }
const _hoisted_24 = { class: "col-lg-6 fv-row" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Status", -1)
const _hoisted_26 = ["label", "value"]
const _hoisted_27 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_28 = { class: "fv-help-block" }
const _hoisted_29 = { class: "col-lg-6 fv-row" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Note", -1)
const _hoisted_31 = { class: "fv-plugins-message-container" }
const _hoisted_32 = { class: "fv-help-block" }
const _hoisted_33 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_34 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Simpan ", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Silahkan Tunggu ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_37 = [
  _hoisted_35,
  _hoisted_36
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          id: "kt_account_profile_details_form",
          class: "form",
          novalidate: "novalidate",
          onSubmit: _cache[7] || (_cache[7] = ($event: any) => (_ctx.saveChanges1()))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "responsiblePerson",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Nama Sekolah",
                    modelValue: _ctx.editDetail.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editDetail.name) = $event)),
                    disabled: ""
                  }, null, 8, ["modelValue"]),
                  (_ctx.editDetail.name == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.items.errorNamaSekolah), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "number",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Nomor PKS",
                    modelValue: _ctx.editDetail.number,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editDetail.number) = $event))
                  }, null, 8, ["modelValue"]),
                  (_ctx.editDetail.number == '' || _ctx.editDetail.number == null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.items.errorNomorPks), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode(_component_Field, {
                    type: "date",
                    name: "startDate",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Tanggal Mulai",
                    modelValue: _ctx.editDetail.startDate,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editDetail.startDate) = $event))
                  }, null, 8, ["modelValue"]),
                  (_ctx.editDetail.startDate == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.items.errorStartDate), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode(_component_Field, {
                    type: "date",
                    name: "expiredDate",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Tanggal Selesai",
                    modelValue: _ctx.editDetail.expiredDate,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editDetail.expiredDate) = $event))
                  }, null, 8, ["modelValue"]),
                  (_ctx.editDetail.expiredDate == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.items.errorEndDate), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode(_component_Field, {
                    as: "select",
                    class: "form-select form-select-lg fw-bold",
                    name: "status",
                    modelValue: _ctx.editDetail.status,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editDetail.status) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.listStatus, (option) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: option,
                          label: option,
                          value: option
                        }, null, 8, _hoisted_26))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  (_ctx.editDetail.status == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.items.errorStatus), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _withDirectives(_createElementVNode("textarea", {
                    type: "text",
                    name: "note",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Note",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editDetail.note) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.editDetail.note]
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_component_ErrorMessage, { name: "note" })
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("button", {
                class: "btn btn-danger me-3",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push('/superadmin/legal/legalitas/')))
              }, " Batal "),
              _createElementVNode("button", _hoisted_34, _hoisted_37, 512)
            ])
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}